import { useToast } from "@chakra-ui/react";
import * as Sentry from "@sentry/react";
import { getApiUserErrorMessage } from "../api/nest-api";

type ShowErrorParams = {
  title?: string;
  description: string;
};

const asUndefinedIfEmpty = (value: string | undefined): string | undefined => {
  return value?.trim() ? value : undefined;
};

export const useGenericErrorHandler = () => {
  const toast = useToast();

  const showError = ({ title, description }: ShowErrorParams) => {
    toast({
      title,
      description,
      status: "error",
      duration: 5000,
      isClosable: true,
    });
  };

  const handleError = (
    error: unknown,
    fallbackMessage = "Es ist ein unerwarteter Fehler aufgetreten",
  ) => {
    Sentry.captureException(error);

    const apiErrorMessage = getApiUserErrorMessage(error);
    const genericErrorMessage =
      error instanceof Error ? error.message : undefined;
    const description =
      asUndefinedIfEmpty(apiErrorMessage) ??
      asUndefinedIfEmpty(genericErrorMessage) ??
      fallbackMessage;

    showError({ description });
  };

  return {
    handleError,
    showError,
  };
};
